import React from 'react'

import Posts from './components/Posts/Post'

export const Home: React.FC = () => {
  return <Posts />
}
